import { render, staticRenderFns } from "./LocationStep.vue?vue&type=template&id=5bb4b766"
import script from "../../../scripts/partials/add-capacity-equipment-steps/LocationStep.js?vue&type=script&lang=js&external"
export * from "../../../scripts/partials/add-capacity-equipment-steps/LocationStep.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports